import { Activity } from "lucide-react";

import { Button } from "@/common/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/common/ui/card";

interface ConnectDeviceCardProps {
  onConnect: (provider: string) => void;
  isLoading: boolean;
}

export function ConnectDeviceCard({
  onConnect,
  isLoading,
}: ConnectDeviceCardProps): React.ReactElement {
  return (
    <Card data-testid="connect-device-card" className="mx-auto max-w-md">
      <CardHeader className="text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
          <Activity className="h-8 w-8 text-primary" />
        </div>
        <CardTitle>Connect a Device</CardTitle>
        <CardDescription>
          Link your wearable device to view health and fitness data.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-4">
        <Button
          data-testid="connect-whoop-button"
          onClick={() => onConnect("whoop")}
          disabled={isLoading}
          className="w-full max-w-xs"
        >
          {isLoading ? "Connecting..." : "Connect Whoop"}
        </Button>
        <p className="text-xs text-muted-foreground">
          Securely connects via OAuth. Your credentials are never stored.
        </p>
      </CardContent>
    </Card>
  );
}
